import { CustomTabInfo, TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { RootState } from 'editor/src/store/index';

const hasSidebarTab = (state: RootState, tabName: TAB_NAMES) =>
  state.editorModules.sidebar.tabs.some((tab) => tab === tabName || (tab as CustomTabInfo).id === tabName);

export default hasSidebarTab;
